import React from "react";
import AudioPlayer from "react-modular-audio-player";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import FileSaver from "file-saver";
import InfiniteScroll from "react-infinite-scroller";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { Tooltip } from "antd";
import { serverDomain } from "../../../config";
import {
  getAllMedia,
  onPublishedFile,
  getMediaByTag
} from "../../../services/upload";
import { connect } from "react-redux";
import playIcon from "../../../../playIcon.png";
import pauseIcon from "../../../../pauseIcon.png";
import downloadIcon from "../../../../download_icon.png";

const rearrangedPlayer = [
  {
    className: "adele",
    innerComponents: [
      {
        type: "play",
        style: {
          width: "100%",
          justifyContent: "center",
          opacity: "1"
        }
      }
    ]
  }
];

class Gallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: null,
      photoIndex: 0,
      isOpen: false,
      isRingtone: false,
      hasMoreItems: true
    };
  }

  loadItems = async page => {
    const { mediaType, fileList, path } = this.props;
    const isFind = path.indexOf("find") > -1 || false;
    const publish =
      path.indexOf("admin") !== -1
        ? `&publish=${false}`
        : path.indexOf("profile") !== -1
        ? {}
        : `&publish=${true}`;
    const type =
      mediaType === "ringtones"
        ? "&mediaType=ringTone"
        : mediaType === "wallpapers"
        ? "&mediaType=wallPaper"
        : "";

    let data = {};
    if (isFind) {
      data = await getMediaByTag(
        path.split("/")[3],
        `currentPage=${page}&size=${5}${type}`
      );
    } else {
      data = await getAllMedia(
        `currentPage=${page}&size=${5}${publish}${type}`
      );
    }

    if (data && data.done && data.media.data.length) {
      this.props.getFileList(data && data.media && data.media.data);
    }
    if (
      fileList &&
      fileList.length === data &&
      data.media &&
      data.media.metadata &&
      data.media.metadata.total
    ) {
      this.setState({
        hasMoreItems: false
      });
    }
  };

  onPublished = id => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Published It!",
      cancelButtonText: "Not Published!",
      reverseButtons: true
    }).then(result => {
      if (result.value) {
        Swal.fire({
          title: "Are you sure?",
          text: "You want to published the file!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Published It!"
        }).then(async result => {
          if (result.value) {
            const response = await onPublishedFile(id, { publish: true });
            if (response && response.success) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Your file published successfully!",
                showConfirmButton: false,
                timer: 2000
              });
            }
          }
        });
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        Swal.fire("Cancelled", "Your imaginary file is safe :)", "error");
      }
    });
  };

  render() {
    const { fileList, path } = this.props;
    const { isOpen, photoIndex, hasMoreItems, isRingtone } = this.state;
    const loader = (
      <div key={0} className="loader">
        ...
      </div>
    );

    const images = fileList && fileList.map(m => m.imagePath);
    const items = [];

    if (fileList && fileList.length) {
      fileList &&
        fileList.length &&
        fileList.map((media, index) => {
          const type =
            (media && media.imagePath && media.imagePath.split(".").pop()) ||
            "";

          items.push(
            <div
              className="col-md-4 col-sm-6 col-lg-3 col-xl-2"
              key={index.toString()}
              style={{ padding: 5 }}
            >
              <div className="card">
                <div>
                  {["jpeg", "jpg", "png", "gif"].indexOf(type) > -1 ? (
                    <div>
                      <img
                        className="card-img-top"
                        src={media.imagePath}
                        alt="preview_image"
                        style={{
                          height: 450,
                          margin: 0,
                          cursor: "pointer",
                          objectFit: "cover"
                        }}
                        onClick={() =>
                          this.setState({
                            isOpen: true,
                            photoIndex: index
                          })
                        }
                      />
                      <div className="img-text">
                        {path.indexOf("admin") !== -1 ? (
                          <Tooltip placement="bottom" title="Review Image">
                            <span className="d-inline-block btn float-right">
                              <i
                                className="fas fa-eye"
                                style={{
                                  fontSize: 30,
                                  color: "#1590f4",
                                  cursor: "pointer"
                                }}
                                onClick={() => this.onPublished(media._id)}
                              />
                            </span>
                          </Tooltip>
                        ) : null}

                        <h5 style={{ marginTop: 8, color: "white" }}>
                          {media.title}
                        </h5>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div
                        className="audio-background card-img-top"
                        onClick={() =>
                          this.setState({
                            isOpen: true,
                            isRingtone: true,
                            photoIndex: index
                          })
                        }
                      >
                        <div
                          className="audio-div"
                          onClick={e => {
                            e.stopPropagation();
                          }}
                        >
                          <AudioPlayer
                            audioFiles={[
                              {
                                src: `${serverDomain}${media.imagePath}`,
                                title: "Rolling In The Deep",
                                artist: "Adele"
                              }
                            ]}
                            playIcon={playIcon}
                            pauseIcon={pauseIcon}
                            rearrange={rearrangedPlayer}
                            playerWidth="auto"
                            iconSize="9rem"
                          />
                        </div>
                      </div>

                      <span className="img-text">
                        {path.indexOf("admin") !== -1 ? (
                          <span
                            className="d-inline-block btn float-right"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.onPublished(media._id)}
                          >
                            <Tooltip
                              placement="bottom"
                              title="Review Image"
                              onClick={() => this.onPublished(media._id)}
                            >
                              <i
                                className="fas fa-eye"
                                style={{
                                  fontSize: 20,
                                  color: "#1590f4"
                                  // cursor: "pointer"
                                }}
                                onClick={() => this.onPublished(media._id)}
                              />
                            </Tooltip>
                          </span>
                        ) : null}
                        <span>
                          <h5 className="img-text">{media.title}</h5>
                        </span>
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
          return null;
        });
    }

    const ringtoneLightBox = () => {
      return (
        <Lightbox
          mainSrc={images[photoIndex]}
          // nextSrc={images[(photoIndex + 1) % images.length]}
          // prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() =>
            this.setState({ isOpen: false, isRingtone: false })
          }
          // enableZoom={false}
          imageLoadErrorMessage={
            <div className="audio-background-view">
              <div className="audio-view-div">
                <AudioPlayer
                  audioFiles={[
                    {
                      src: images[photoIndex],
                      title: "Rolling In The Deep",
                      artist: "Adele"
                    }
                  ]}
                  playIcon={playIcon}
                  pauseIcon={pauseIcon}
                  rearrange={rearrangedPlayer}
                  playerWidth="auto"
                  iconSize="9rem"
                />
              </div>
            </div>
          }
          imageTitle={fileList[photoIndex].title}
          imageCaption={
            path.indexOf("admin") > -1
              ? []
              : fileList[photoIndex].tag.map(tags => (
                  <a href={`/find/ringtones-wallpapers/${tags}`}>
                    <span
                      className="badge badge-pill badge-light"
                      style={{ marginRight: 5, cursor: "pointer" }}
                    >
                      {tags.charAt(0).toUpperCase() + tags.slice(1)}
                    </span>
                  </a>
                ))
          }
          enableZoom={false}
          // discourageDownloads="For Download Image"
          // clickOutsideToClose
          toolbarButtons={[
            <img
              src={downloadIcon}
              //className="fas fa-arrow-down"
              alt="download"
              onClick={() =>
                FileSaver.saveAs(
                  images[photoIndex],
                  fileList[photoIndex].fileName || "file.jpg"
                )
              }
              style={{
                cursor: "pointer",
                verticalAlign: "middle",
                width: 20,
                marginRight: 10,
                height: 20
              }}
            />
          ]}
        />
      );
    };
    const imageLightBox = () => {
      return (
        <Lightbox
          mainSrc={images[photoIndex]}
          // nextSrc={images[(photoIndex + 1) % images.length]}
          // prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() =>
            this.setState({ isOpen: false, isRingtone: false })
          }
          // enableZoom={false}
          imageTitle={fileList[photoIndex].title}
          imageCaption={
            path.indexOf("admin") > -1
              ? []
              : fileList[photoIndex].tag.map(tags => (
                  <a href={`/find/ringtones-wallpapers/${tags}`}>
                    <span
                      className="badge badge-pill badge-light"
                      style={{ marginRight: 5, cursor: "pointer" }}
                    >
                      {tags.charAt(0).toUpperCase() + tags.slice(1)}
                    </span>
                  </a>
                ))
          }
          nextSrcThumbnail={images[photoIndex + 1]}
          prevLabel={images[photoIndex + 1]}
          // discourageDownloads="For Download Image"
          // clickOutsideToClose
          toolbarButtons={[
            <img
              src={downloadIcon}
              className="fas fa-arrow-down"
              alt="download"
              onClick={() =>
                FileSaver.saveAs(
                  images[photoIndex],
                  fileList[photoIndex].fileName || "file.jpg"
                )
              }
              style={{
                cursor: "pointer",
                verticalAlign: "middle",
                width: 20,
                marginRight: 10,
                height: 20
              }}
            />
          ]}
          onMovePrevRequest={() =>
            this.setState({
              photoIndex: (photoIndex + images.length - 1) % images.length
            })
          }
          onMoveNextRequest={() =>
            this.setState({
              photoIndex: (photoIndex + 1) % images.length
            })
          }
        />
      );
    };

    return (
      <div>
        <InfiniteScroll
          pageStart={-1}
          loadMore={this.loadItems}
          hasMore={hasMoreItems}
          loader={loader}
        >
          <div className="row">{items}</div>
        </InfiniteScroll>

        {isOpen && (isRingtone ? ringtoneLightBox() : imageLightBox())}
      </div>
    );
  }
}

// export default Gallery
const mapStateToProps = state => {
  return {
    userDetails: state && state.loginUser
  };
};
export default connect(mapStateToProps)(Gallery);
